module.exports = __webpack_public_path__ + "static/media/Crypto_compute (1) 1.0228dc6a.png";